/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import Loadable from 'react-loadable';
import CoreException from './Error';
import { Loading } from '../components/Loading';

const getComponent = loader => ({
  loader,
  loading: props => {
    if (props.error) {
      return <CoreException desc={props.error.toString()} />;
    } else if (props.timedOut) {
      return (
        <CoreException
          desc="页面加载超时"
          onBtnClick={() => {
            window.location.reload();
          }}
          btnText="点我重试"
        />
      );
    } else if (props.pastDelay) {
      return <Loading />;
    }
    return null;

  }
});

const env = process.env.NODE_ENV || 'development';
const isDev = env === 'development';
const routes = [
  ...(isDev ? [{
    path: '/h5_fe_preg/html/',
    title: '宝宝树孕育',
    exact: true,
    strict: true, // 为了使用serviceWorker，这里必须为true，因为如果使用/h5_fe_preg/html 这个路径sw不会生效
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "DemoIndex" */ 'pages/Demo/pages/Index/index.jsx'
      )
      )
    )
  }] : []),
  {
    path: '/h5_fe_preg/html/circle_detail',
    title: '圈子详情页分享页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CircleDetail" */ 'pages/Circle/pages/CircleDetail/pages/Index/index.jsx'
      )
      )
    )
  },
  // {
  //   path: '/h5_fe_preg/html/circle/base_setting/index',
  //   title: '圈子基本信息设置',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "BaseSettingIndex" */ 'pages/Circle/pages/BaseSetting/index.jsx'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/circle/call_setting/index',
  //   title: '圈成员称呼设置',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "CallSettingIndex" */ 'pages/Circle/pages/CallSetting/index.jsx'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/circle/topic_setting/index',
  //   title: '话题设置',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "TopicSettingIndex" */ 'pages/Circle/pages/TopicSetting/index.jsx'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/circle/label_setting/index',
  //   title: '圈子标签',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "LabelSettingIndex" */ 'pages/Circle/pages/LabelSetting/index.jsx'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/circle/welcome_setting/index',
  //   title: '圈子欢迎弹窗',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "WelcomeSettingIndex" */ 'pages/Circle/pages/WelcomeSetting/index.jsx'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/circle/tab_setting/index',
  //   title: '圈子tab设置',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "TabSettingIndex" */ 'pages/Circle/pages/TabSetting/index.jsx'
  //       )
  //     )
  //   )
  // },
  {
    path: '/h5_fe_preg/html/babychange/index',
    title: '孕育周刊',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "Index" */ 'pages/BabyChange/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/babychange/dad',
    title: '准爸爸周刊',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "DadIndex" */ 'pages/BabyChange/pages/Dad/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/babychange/list',
    title: '孕育每日变化',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ListIndex" */ 'pages/BabyChange/pages/List/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/Topic/TopVideo',
    title: '视频帖',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "TopVideo" */ 'pages/Topic/pages/TopicVideo/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/Topic/Subject',
    title: '话题',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "Subject" */ 'pages/Topic/pages/Subject/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/Topic/Disscussion',
    title: '帖子分享页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "TopDisscussion" */ 'pages/Topic/pages/Discussion/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/feed/rankinglist',
    title: '宝宝树孕育排行榜',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "FeedRankingList" */ 'pages/Feed/pages/RankingList/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/redirect/miniprogram',
    title: '宝宝树孕育',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RedirectMiniProgram" */ 'pages/Redirect/pages/MiniProgram/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/redirect/app',
    title: '宝宝树孕育',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RedirectAPP" */ 'pages/Redirect/pages/APP/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/redirect/apptool',
    title: 'h5万能页生成器',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RedirectAPPTool" */ 'pages/Redirect/pages/APP/Tool.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/business/home',
    title: '商家个人主页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "BusinessIndex" */ 'pages/Business/pages/Home/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/private/create',
    title: '创建私密圈',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivateCircleCreate" */ 'pages/Circle/pages/PrivateCircle/create/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/private/about',
    title: '关于私密圈',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivateCircleAbout" */ 'pages/Circle/pages/PrivateCircle/about/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/private/management',
    title: '管理私密圈',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivateCircleManagement" */ 'pages/Circle/pages/PrivateCircle/management/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/private/audit',
    title: '圈子成员加入审核',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivateCircleAudit" */ 'pages/Circle/pages/PrivateCircle/audit/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/private/share',
    title: '私密圈邀请',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivateCircleShare" */ 'pages/Circle/pages/PrivateCircle/share/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/private/sucess',
    title: '私密圈邀请成功',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivateCircleSucess" */ 'pages/Circle/pages/PrivateCircle/sucess/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/community/recommend',
    title: '小区--推荐小区',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CommunityRecommend" */ 'pages/Circle/pages/Community/recommend/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/community/choose',
    title: '小区--手动选择小区',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CommunityChoose" */ 'pages/Circle/pages/Community/choose/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/circle/community/citySelect',
    title: '小区--手动选择城市',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CommunityCitySelect" */ 'pages/Circle/pages/Community/citySelect/index.jsx'
      )
      )
    )
  },
  // {
  //   path: '/h5_fe_preg/html/motherontest/home',
  //   title: '妈妈大赛首页',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "MotherContestHome" */ 'pages/MotherContest/pages/home/index.jsx'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/motherontest/ranking',
  //   title: '妈妈大赛回答榜',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "MotherContestRanking" */ 'pages/MotherContest/pages/ranking/index.jsx'
  //       )
  //     )
  //   )
  // },
  {
    path: '/h5_fe_preg/html/invite/index',
    title: '宝宝树孕育',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "InviteBind" */ 'pages/Invite/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/invite/lover',
    title: '邀请伴侣',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "InviteLover" */ 'pages/Invite/pages/Lover/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/index',
    title: '宝宝树直播间',
    exact: true,
    component: Loadable(
      getComponent(() => import(/* webpackChunkName: "LiveIndex" */ 'pages/Live/pages/Index')
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/redpacketlist',
    title: '直播红包明细',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "LiveRedPacketList" */ 'pages/Live/pages/RedPacketList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/luckybag',
    title: '直播倒计时福袋',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "LuckyBagIndex" */ 'pages/Live/pages/LuckyBag'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/advance',
    title: '直播预告',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AdvanceIndex" */ 'pages/Live/pages/Advance'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/landscape',
    title: '宝宝树直播间',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "LiveLandscape" */ 'pages/Live/pages/Landscape'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/mtlive',
    title: '美囤live',
    exact: true,
    component: Loadable(
      getComponent(() => import(/* webpackChunkName: "MTLive" */ 'pages/Live/pages/MTLive')
      )
    )
  },
  {
    path: '/h5_fe_preg/html/live/LiveList',
    title: '直播列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(/* webpackChunkName: "LiveList" */ 'pages/Live/pages/LiveList')
      )
    )
  },
  {
    path: '/h5_fe_preg/html/home/loveinvite',
    title: '爱爱邀请',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "LoveInvite" */ 'pages/Home/pages/LoveInvite'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/agreement',
    title: '宝宝树协议',
    exact: true,
    component: Loadable(
      getComponent(() => import(/* webpackChunkName: "Agreement" */ 'pages/Agreement')
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/growthsystem/userlevel',
    title: '我的成长',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowthsystemUserlevel" */ 'pages/User/GrowthSystem/pages/UserLevel'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/growthsystem/rules',
    title: '用户LV等级体系规则说明',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowthsystemRules" */ 'pages/User/GrowthSystem/pages/Rules'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/growthsystem/levelAbout',
    title: '权益说明',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowthsystemLevelAbout" */ 'pages/User/GrowthSystem/pages/LevelAbout'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/growthsystem/growthValue',
    title: '成长值明细',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowthsystemGrowthValue" */ 'pages/User/GrowthSystem/pages/GrowthValue'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/growthsystem/exChangeDetail',
    title: '成长值兑换详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowthsystemExChangeDetail" */ 'pages/User/GrowthSystem/pages/ExChangeDetail'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/growthsystem/orderpay',
    title: '订单详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowthsystemOrderPay" */ 'pages/User/GrowthSystem/pages/OrderPay'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/preg_app_share/index',
    title: '宝宝树孕育',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregAppShareIndex" */ 'pages/User/PregAppShare/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/shortcut/food/index',
    title: '喂养记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ShortcutFoodIndex" */ 'pages/User/Shortcut/pages/Food/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/shortcut/contractionRecord/index',
    title: '记宫缩',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ShortcutContractionRecordIndex" */ 'pages/User/Shortcut/pages/ContractionRecord/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/shortcut/pregdiary/index',
    title: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ShortcutPregDiaryIndex" */ 'pages/User/Shortcut/pages/PregDiary/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/shortcut/ai_tools/index',
    title: '',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ShortcutAIToolsIndex" */ 'pages/User/Shortcut/pages/AITools/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/system_permission/index',
    title: '系统权限调用目录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicySystemPermissionIndex" */ 'pages/User/PrivacyPolicy/SystemPermission/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/other_sdk/index',
    title: '第三方共享个人信息清单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyOtherSdkIndex" */ 'pages/User/PrivacyPolicy/OtherSdk/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/ad_info/index',
    title: '广告信息共享清单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyAdInfoIndex" */ 'pages/User/PrivacyPolicy/AdInfo/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/preg_privacy/index',
    title: '宝宝树平台隐私政策',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyPregPrivacyIndex" */ 'pages/User/PrivacyPolicy/PregPrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/caneat_privacy/index',
    title: '宝宝树食物通隐私政策',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyCaneatPrivacyIndex" */ 'pages/User/PrivacyPolicy/CaneatPrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/wetime_privacy/index',
    title: '宝宝树小时光平台隐私政策',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyWetimePrivacyIndex" */ 'pages/User/PrivacyPolicy/WetimePrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/preg_terms_privacy/index',
    title: '宝宝树平台服务协议',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyTermsPrivacyIndex" */ 'pages/User/PrivacyPolicy/TermsPrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/terms_privacy/index',
    title: '宝宝树平台服务协议',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyWetimeTermsPrivacyIndex" */ 'pages/User/PrivacyPolicy/WetimeTermsPrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/wetime_promo_privacy/index',
    title: '更新提醒',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyWetimePromoPrivacyIndex" */ 'pages/User/PrivacyPolicy/WetimePromoPrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/privacy_policy/wetime_other_sdk/index',
    title: '第三方共享个人信息清单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyWetimeOtherSdkIndex" */ 'pages/User/PrivacyPolicy/WetimeOtherSdk/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/preg_app_notice/index',
    title: '公告',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrivacyPolicyNoticeIndex" */ 'pages/User/PrivacyPolicy/NoticePrivacy/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/export_user_info/index',
    title: '个人信息',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ExportUserInfoIndex" */ 'pages/User/ExportUserInfo/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/grass_rules/index',
    title: '种草规则',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrassRulesInfoIndex" */ 'pages/User/GrassRules/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/newborngift/index',
    title: '新生礼包',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "NewBornGiftIndex" */ 'pages/User/NewBornGift/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/userinfolist/index',
    title: '个人信息清单收集与使用清单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "UserInfoListIndex" */ 'pages/User/UserInfoList/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/userinfolist/base',
    title: '用户基本信息',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "UserInfoListBase" */ 'pages/User/UserInfoList/pages/Base'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/userinfolist/baselist',
    title: '信息收集情况',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "UserInfoListBaseList" */ 'pages/User/UserInfoList/pages/BaseList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/open/aggregation',
    title: '内容聚合',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "OpenAggregation" */ 'pages/Open/pages/Aggregation'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/open/aggregation/videoshare',
    title: '内容聚合_视频分享页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "OpenAggregationVideoShare" */ 'pages/Open/pages/Aggregation/VideoShare'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/open/foodlist',
    title: '一周辅食餐单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "OpenFoodList" */ 'pages/Open/pages/FoodList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/index',
    title: '宝树创造营',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsIndex" */ 'pages/Activity/Creators/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/rules',
    title: '宝树创造营',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsRules" */ 'pages/Activity/Creators/pages/Rules'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/rank',
    title: '创作者热度排行榜',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsRank" */ 'pages/Activity/Creators/pages/Rank'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/my',
    title: '我的创作',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsMy" */ 'pages/Activity/Creators/pages/My'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/creators_report',
    title: '创作者月报',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CreatorsReport" */ 'pages/Activity/Creators/pages/CreatorsReport'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/interested',
    title: '你可能感兴趣的人',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsInterestedList" */ 'pages/Activity/Creators/pages/InterestedList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/center',
    title: '创作者中心',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsCenter" */ 'pages/Activity/Creators/pages/CreatorsCenter'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/level',
    title: '创作者中心',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsLevel" */ 'pages/Activity/Creators/pages/Center'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/unauthorized',
    title: '创作中心',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsUnauthorized" */ 'pages/Activity/Creators/pages/CreatorsCenter'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/inspiration',
    title: '创作灵感',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CreativeInspiration" */ 'pages/Activity/Creators/pages/CreatorsCenter/CreativeInspiration'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/motivation',
    title: '创作激励',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CreativeMotivation" */ 'pages/Activity/Creators/pages/CreatorsCenter/CreativeMotivation'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/center/rules',
    title: '规则说明',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsCenterRules" */ 'pages/Activity/Creators/pages/Center/Rules'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/medal',
    title: '我的勋章',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsMedal" */ 'pages/Activity/Creators/pages/Medal'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/megagame/index',
    title: '奔跑吧，创作者',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CreatorsGameIndex" */ 'pages/Activity/Creators/pages/CreatorsGame/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/megagame/detail',
    title: '奔跑吧，创作者',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CreatorsGameDetail" */ 'pages/Activity/Creators/pages/CreatorsGame/pages/Detail'
      )
      )
    )
  },
  // {
  //   path: '/h5_fe_preg/html/activity/yearactivity/index',
  //   title: '2020年终活动',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "YearEndIndexActivity" */ 'pages/Activity/YearEndActivity/pages/Index'
  //         )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/yearactivity/select',
  //   title: '2020年终活动',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "YearEndSelectActivity" */ 'pages/Activity/YearEndActivity/pages/Select'
  //         )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/yearactivity/result',
  //   title: '2020年终活动',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "YearEndResultActivity" */ 'pages/Activity/YearEndActivity/pages/Result'
  //         )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/newyear/index',
  //   title: '我的2021孕育旅程',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "NewYearActivity" */ 'pages/Activity/NewYear/pages/Index'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/newyear/agreement',
  //   title: '我的2021孕育旅程',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "NewYearActivityAgreement" */ 'pages/Activity/NewYear/pages/Agreement'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/newyear/sharehelp/index',
  //   title: '我的2021孕育旅程',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "NewYearActivityHelp" */ 'pages/Activity/NewYear/pages/ShareHelp/Index'
  //       )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/newyear/blind_box_Rule',
  //   title: '我的2021孕育旅程',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() =>
  //       import(
  //         /* webpackChunkName: "NewYearActivityBindBoxRule" */ 'pages/Activity/NewYear/pages/Blind_box_Rule'
  //       )
  //     )
  //   )
  // },

  // {
  //   path: '/h5_fe_preg/html/activity/whitepaper/index',
  //   title: '母婴家庭健康白皮书',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() => import(
  //       /* webpackChunkName: "WhitePaperActivity" */ 'pages/Activity/WhitePaper/pages/Index'
  //     )
  //     )
  //   )
  // },

  // {
  //   path: '/h5_fe_preg/html/activity/ksong/index',
  //   title: '辣妈K歌赛',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() => import(
  //       /* webpackChunkName: "LamaKSongIndex" */ 'pages/Activity/LamaKSong/pages/Index'
  //     )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/ksong/detail',
  //   title: '辣妈K歌赛',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() => import(
  //       /* webpackChunkName: "LamaKSongDetail" */ 'pages/Activity/LamaKSong/pages/Detail'
  //     )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/dragshow/index',
  //   title: '国潮萌宝视频秀大赛',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() => import(
  //       /* webpackChunkName: "ActivityDragShowIndex" */ 'pages/Activity/DragShow/pages/Index'
  //     )
  //     )
  //   )
  // },
  // {
  //   path: '/h5_fe_preg/html/activity/dragshow/detail',
  //   title: '国潮萌宝视频秀大赛',
  //   exact: true,
  //   component: Loadable(
  //     getComponent(() => import(
  //       /* webpackChunkName: "ActivityDragShowDetail" */ 'pages/Activity/DragShow/pages/Detail'
  //     )
  //     )
  //   )
  // },
  {
    path: '/h5_fe_preg/html/activity/painting/index',
    title: '绘画报名',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityPaintingIndex" */ 'pages/Activity/Painting/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/painting/rules',
    title: '绘画报名规则页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityPaintingRules" */ 'pages/Activity/Painting/pages/Rules'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/painting/minephotolist',
    title: '我的绘画列表页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityPaintingMinePhotoList" */ 'pages/Activity/Painting/pages/MinePhotoList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/painting/uploadphoto',
    title: '上传绘画页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityPaintingMineUploadPhoto" */ 'pages/Activity/Painting/pages/UploadPhoto'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/painting/mineinfo',
    title: '我的个人信息上传页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityPaintingMineMineInfo" */ 'pages/Activity/Painting/pages/MineInfo'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/fusonreg/index',
    title: '宝宝树福利放送',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityFusonRegIndex" */ 'pages/Activity/FusonReg/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/administer/advertisement',
    title: '广告管理',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AdministerAdvertisementAdmin" */ 'pages/Administer/pages/AdvertisementAdmin'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/administer/recommend',
    title: '推荐管理',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AdministerRecommendAdmin" */ 'pages/Administer/pages/RecommendAdmin'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/stardoctor/index',
    title: '小星医生历史记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "StarDoctorIndex" */ 'pages/StarDoctor/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/stardoctor/doctordetail',
    title: '小星医生历史记录-问医生详情页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "StarDoctorDoctordetail" */ 'pages/StarDoctor/pages/DoctorDetail'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/creatorscenter/creativecollege',
    title: '创作学院列表页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsCreatorsCenterCreativeCollege" */ 'pages/Activity/Creators/pages/CreatorsCenter/CreativeCollege'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/creators/creatorscenter/creativetaskcenter',
    title: '创作者任务中心-任务详情页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ActivityCreatorsCreatorsCenterCreativeTaskCenter" */ 'pages/Activity/Creators/pages/CreatorsCenter/CreativeTaskCenter'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/answerday/index',
    title: '每日一答-首页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AnswerDayIndex" */ 'pages/AnswerDay/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/answerday/titlereview',
    title: '题目回顾',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AnswerDayTitleReview" */ 'pages/AnswerDay/pages/TitleReview'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/postsList/index',
    title: '最新帖子列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PostsListIndex" */ 'pages/PostsList/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aistory/animationn1',
    title: 'AI讲故事-N1动画',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryAnimationN1" */ 'pages/AI/AIStory/pages/AnimationN1'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aistory/animationn2',
    title: 'AI讲故事-N2动画',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryAnimationN2" */ 'pages/AI/AIStory/pages/AnimationN2'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aistory/animationn3',
    title: 'AI讲故事-N3动画',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryAnimationN3" */ 'pages/AI/AIStory/pages/AnimationN3'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aistory/agreement',
    title: '智能语音定制服务协议',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryAgreement" */ 'pages/AI/AIStory/pages/Agreement'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aistory/aishare',
    title: '爸妈AI讲故事',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryShare" */ 'pages/AI/AIStory/pages/AIStoryShare'
      )
      )
    )
  },

  {
    path: '/h5_fe_preg/html/aistory/verification',
    title: 'AI讲故事验证码输入页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryVerification" */ 'pages/AI/AIStory/pages/AIVerification'
      )
      )
    )
  },

  {
    path: '/h5_fe_preg/html/aistory/ainewyear',
    title: 'AI讲故事新年活动页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryAiNewyear" */ 'pages/AI/AIStory/pages/AINewYear'
      )
      )
    )
  },

  {
    path: '/h5_fe_preg/html/aistory/ainewyear/rules',
    title: 'AI讲故事新年活动规则页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIStoryAiNewyearAINewYearRules" */ 'pages/AI/AIStory/pages/AINewYearRules'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aitext/index',
    title: '智能助理',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AITextIndex" */ 'pages/AI/AIText/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aitext/redpacket/index',
    title: '红包雨',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RedPacketIndex" */ 'pages/AI/AIText/pages/RedPacket'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_image/index',
    title: 'AI灵感',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIImageIndex" */ 'pages/AI/AIImage/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_chat/index',
    title: 'GK小博士',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIChatIndex" */ 'pages/AI/AIChat/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_bscan/index',
    title: 'B超解读',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBScanIndex" */ 'pages/AI/AIBScan/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/cartoon/index',
    title: '动漫表情包',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CartoonIndex" */ 'pages/Cartoon/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/cartoon/detail',
    title: '动漫表情包详情页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CartoonDetail" */ 'pages/Cartoon/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/app/logout',
    title: '注销账号',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AppLogout" */ 'pages/AppLogout/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/app/logout/note',
    title: '注销账号-重要提醒',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AppLogoutNote" */ 'pages/AppLogout/pages/Note'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/app/logout/verification',
    title: '注销账号-验证',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AppLogoutVerification" */ 'pages/AppLogout/pages/Verification'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/app/logout/confirm',
    title: '注销账号-确认',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AppLogoutConfirm" */ 'pages/AppLogout/pages/Confirm'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/app/logout/complete',
    title: '注销账号-完成',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AppLogoutComplete" */ 'pages/AppLogout/pages/Complete'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/pregaboutUsrules',
    title: '关于我们',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "UserPregAboutUsRules" */ 'pages/User/PregAboutUsRules'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/user/pregrule',
    title: '宝宝树版规',
    exact: true,
    component: Loadable(
      getComponent(() => import(/* webpackChunkName: "UserPregRule" */ 'pages/User/PregRule')
      )
    )
  },
  {
    path: '/h5_fe_preg/html/quesstionstar/index',
    title: '米卡问答是否满意',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "QuesstionStar" */ 'pages/QuestionStar/pages/index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/mika_make_name/index',
    title: '米卡AI起名',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIMakeName" */ 'pages/User/AIMakeName/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/mika_make_name/history',
    title: '米卡AI起名历史记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIMakeNameHistoryList" */ 'pages/User/AIMakeName/pages/HistoryList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/mika_make_name/result',
    title: '米卡AI起名',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIMakeName" */ 'pages/User/AIMakeName/pages/NameResult'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/mikabot/index',
    title: '智能米卡',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIMakeName" */ 'pages/User/MikaBot/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/highneedbaby/index',
    title: '高需求宝宝研究中心',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HighNeedBabyIndex" */ 'pages/Activity/HighNeedBaby/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/highneedbaby/picture',
    title: '高需求宝宝图卡',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HighNeedBabyPictureIndex" */ 'pages/Activity/HighNeedBaby/pages/Picture'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/snake_invite/index',
    title: '灵蛇报福集好运，赢树钻换好礼',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "SnakeInviteIndex" */ 'pages/Activity/SnakeInvite/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/snake_invite/invite',
    title: '灵蛇报福集好运，赢树钻换好礼',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "SnakeInviteInvite" */ 'pages/Activity/SnakeInvite/pages/Invite'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/snake_invite/Rule',
    title: '灵蛇报福集好运，赢树钻换好礼',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "SnakeInviteRule" */ 'pages/Activity/SnakeInvite/pages/Rule'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_looks/index',
    title: '预测宝宝长相',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastLooksIndex" */ 'pages/AI/AIForecastLooks/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_looks/rule',
    title: '活动声明',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastLooksRule" */ 'pages/AI/AIForecastLooks/pages/Rule'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_looks/history_order',
    title: '预测宝宝长相',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastLooksHistoryOrder" */ 'pages/AI/AIForecastLooks/pages/Mywork'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_growth/index',
    title: '预测宝宝长大',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastGrowthIndex" */ 'pages/AI/AIForecastGrowth/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_growth/my_record_list',
    title: '预测宝宝长大',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastGrowthMyRecordList" */ 'pages/AI/AIForecastGrowth/pages/Mywork'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_growth/make_video',
    title: '预测宝宝长大',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastGrowthMakeVideo" */ 'pages/AI/AIForecastGrowth/pages/MakeVideo'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_growth_ub/index',
    title: '预测宝宝长大',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastGrowthUbIndex" */ 'pages/AI/AIForecastGrowthUb/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/forecast_growth_ub/my_record_list',
    title: '我的作品',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIForecastGrowthUbMyRecordList" */ 'pages/AI/AIForecastGrowthUb/pages/Mywork'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_baby_photos/index',
    title: '宝贝写真',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBabyPhotosIndex" */ 'pages/AI/AIBabyPhotos/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_baby_photos/mywork',
    title: '全部写真',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBabyPhotosMywork" */ 'pages/AI/AIBabyPhotos/pages/Mywork'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_baby_photos/make',
    title: '宝贝写真',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBabyPhotosMake" */ 'pages/AI/AIBabyPhotos/pages/Make'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_baby_photos_ub/index',
    title: '宝贝写真',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBabyPhotosUbIndex" */ 'pages/AI/AIBabyPhotosUb/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_baby_photos_ub/mywork',
    title: '宝贝写真',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBabyPhotosUbMywork" */ 'pages/AI/AIBabyPhotosUb/pages/Mywork'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/ai_baby_photos_ub/make',
    title: '宝贝写真',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AIBabyPhotosUbMake" */ 'pages/AI/AIBabyPhotosUb/pages/Make'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/babywatch/index',
    title: '宝宝看',
    exact: true,
    component: Loadable(
      getComponent(() => import(/* webpackChunkName: "BabyWatchIndex" */ 'pages/User/BabyWatch')
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aiaggregationpage/index',
    title: 'AI聚合页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AiAggregationPage" */ 'pages/AI/AIAggregationPage/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/aiaggregationpage/history',
    title: 'AI聚合页历史记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "AiAggregationHistory" */ 'pages/AI/AIAggregationPage/pages/MyWork'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/package',
    title: '课包详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CoursePackageIndex" */ 'pages/Course/pages/Package'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/album',
    title: '课程专辑',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseAlbumIndex" */ 'pages/Course/pages/Album'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/detail',
    title: '课程详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseDetailIndex" */ 'pages/Course/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/my',
    title: '我的课程',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseMyIndex" */ 'pages/Course/pages/My'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/babylearn/home',
    title: '宝宝学',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseBabyLearnHome" */ 'pages/Course/pages/BabyLearn/pages/Home'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/babylearn/category',
    title: '宝宝学',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseBabyLearnCategory" */ 'pages/Course/pages/BabyLearn/pages/Category'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/babylearn/detail',
    title: '宝宝学-详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseBabyLearnDetail" */ 'pages/Course/pages/BabyLearn/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/course/babylearn/orderlist',
    title: '宝宝学已购内容',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CourseBabyLearnOrderList" */ 'pages/Course/pages/BabyLearn/pages/OrderList'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/mikamember/index',
    title: '米卡大会员',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "MikaMemberIndex" */ 'pages/User/MikaMember/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/activity/horse_invite/invite',
    title: '2026马上有金喜',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HorseInviteInvite" */ 'pages/Activity/HorseInvite/pages/Invite/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_preg/html/2026_cny_template/index',
    title: '宝宝树AI',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "2026CnyTemplate" */ 'pages/AI/2026CnyTemplate/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '*',
    title: '抱歉，您访问的页面不存在！',
    component: require('core/Error/404').default
  }
];

export default routes;
